import { Grid, CircularProgress } from "@mui/material";
import { Form, Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { FormFooter, ReferenceDropDown, TextInput } from "../../components";
import { useGetOneByIdQuery, useUpdateMutation } from "../../features/api/Api";
import { saveHandler } from "../../handlers";
import useLocales from "../../hooks/useLocales";
import { clean, isExists } from "../../utils";
import WorkOrderStatusInput from "../../components/inputs/WorkOrderStatusInput";

const CustomerWorkOrderDetailGeneral = () => {
  const { translate } = useLocales();
  const history = useNavigate();
  const [update] = useUpdateMutation();
  const { id } = useParams();

  const { data: workorder } = useGetOneByIdQuery<any>({
    resource: `fixity/workorder/workorder`,
    id: id,
  });

  function updateMethod(values: any, { setSubmitting }: any) {}

  function submitHandler(values: any, { setSubmitting }: any) {
    saveHandler(clean(values), { setSubmitting }, updateMethod);
  }

  return (
    <>
      {isExists(workorder?.data) ? (
        <Formik initialValues={workorder.data} onSubmit={submitHandler}>
          {(props) => (
            <Form>
              <Grid container spacing={3} justifyContent="center">
                <Grid item md={8} sm={12} xs={12}>
                  <Grid container spacing={3}>
                    <Grid item md={6} sm={6} xs={12}>
                      <ReferenceDropDown
                        name="typeId"
                        label={translate("resources.workOrders.typeId")}
                        optionName="name"
                        reference="fixity/workorder/workOrder/workorder-types"
                        disabled
                      />
                    </Grid>
                    <Grid item md={6}>
                      <WorkOrderStatusInput
                        creatorId={workorder.data.creatorId}
                        disabled={true}
                      />
                    </Grid>

                    <Grid item md={12} sm={12} xs={12}>
                      <TextInput
                        name="title"
                        label={translate("resources.workOrders.title")}
                        disabled={true}
                      />
                    </Grid>

                    <Grid item md={12} sm={12} xs={12}>
                      <TextInput
                        name="description"
                        label={translate("resources.workOrders.description")}
                        multiline
                        rows={4}
                        disabled={true}
                      />
                    </Grid>

                    {/*      <DescriptionHandler /> */}
                  </Grid>
                </Grid>
              </Grid>
              <FormFooter></FormFooter>
            </Form>
          )}
        </Formik>
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default CustomerWorkOrderDetailGeneral;
